import styled from 'vue-styled-components'

export default styled.div`
    & .response-error {
        display: flex;
        background-color: #efefef;        
        padding: 15px;
        max-height: 300px;
        overflow: auto;
        border: 1px solid #cccccc;
        border-radius: 5px;
    }
    & .error-title {
        display: block;
        margin-top: 15px;
        margin-bottom: 10px;
    }
    & .qr-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        & .link-button {
            background-color: #167df0;
            border-color: transparent;
            color: #ffffff !important;
        }
    }
    & .resume {
        & .column {
                & .block  {
                    display: flex;
                    justify-content: center;
                    margin: 0;
                }
        }
    }
`;